import ContentTemplateList from '@/data/contentTemplate/view/ContentTemplateList.vue'
import ContentTemplateEditor from '@/data/contentTemplate/view/ContentTemplateEditor.vue'

const list = {
  path: '/contentTemplate',
  name: 'contentTemplate-list',
  component: ContentTemplateList
}
const creator = {
  path: '/contentTemplate/creator',
  name: 'createContentTemplate',
  component: ContentTemplateEditor
}
const editor = {
  path: '/contentTemplate/editor/:id(\\d+)',
  name: 'updateContentTemplate',
  component: ContentTemplateEditor
}
export default [list, creator, editor]
